<template>
  <div class="main-top" style="height: 100%;">
    <div class="bagimg" style="  min-width: 1200px;" :class="api.state.sidebar.opened ? '' : 'is-action'">
      <div v-if="!style" class="hamburger-container" style="padding-left: 20px">
        <!-- <i :class="api.state.sidebar.opened ? 'el-icon-s-fold' : 'el-icon-s-unfold'" style="font-size: 30px;" @click="toggleSideBar"></i> -->
        <i :class="api.state.sidebar.opened ? 'el-icon-date' : 'el-icon-s-unfold'" style="font-size: 30px;" ></i>
      </div>
      <div style="width: 100%;">
        <div v-if="style" style="height:10px;margin-bottom:-10px;width:100%;display: flex;justify-content:space-between;">
          <dv-decoration-10 :color="['#6771FF', '#fff']" style="width:18%;height:10px;" />
          <dv-decoration-10 :color="['#6771FF', '#fFF']" style="width:18%;height:10px;transform: rotate(180deg);" />
          </div>
        <div v-if="style" style="text-align: center; height:cale( 100% - 20px )" class="flex">
          <div :class="{decorate4:style,decorate3:!style}" style="width:18%; font-size: 30px;font-family: 'oswaldsss';">{{ time }}
            </div>
            <dv-decoration-8 :color="['#6771FF', '#fFF']" class="dv8"/>
            <dv-decoration-11 :color="['#FF986F', '#fff']" style="width:410px;height:80px;margin-bottom:-20px;z-index:100;">  <div class="decorate" :class="{decorate2:style,decorate3:!style}">
              <p style="font-size: 27px;font-weight: bold;">安吉城管智慧厕所监管平台</p>

            </div></dv-decoration-11>

          <dv-decoration-8 :color="['#6771FF', '#fFF']" :reverse="true" class="dv8s" />
          <div style="color:#FFF;width:15%;" class="flex">
            <div class="vertical"></div>
            <div style="cursor: pointer;margin-right: 20px;color: #000;" @click="$router.push({ path: `/guide` });">
              <p>返回首页</p>
              <p style="text-align: center">Home</p>
            </div>
            <el-dropdown style="cursor: pointer;">
              <div class="flex">
                <img :src="user.sex === 'female' ? legend.headImg1 : legend.headImg2" style="width: 50px;"/>
                <div style="text-align: center;margin-left: 10px;color: #000;">
                  <p style="font-size: 18px;">{{ user.realName }}</p>
                  <p style="font-size: 14px;margin-top:3px">{{ user.roleName }}</p>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown" style="border: none">
                <div style="padding: 0 20px;cursor: pointer;">
                  <p @click="signOut()">退出</p>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div v-if="!style" style="padding:0 58px 0 8px;width: 100%;">
        <div style="text-align: center;" class="flex">
          <div :class="{decorate4:style,decorate3:!style}" style="font-size: 30px;font-family: 'oswaldsss';">{{ time }}
            </div>
          <div class="flex-center" :class="{decorate:style}" style="display: flex">
            <div :class="{decorate2:style,decorate3:!style}">
              <p style="font-size: 25px;font-weight: bold;">安吉城管智慧厕所监管平台</p>
              <p :class="{decorate4:style,decorate3:!style}" style="font-size:16px;">An Ji Urban Management Intelligent Toilet Platform</p>
            </div>
          </div>
          <div style="color:#FFF;padding-right:10px;" class="flex">
            <div class="vertical"></div>
            <div style="cursor: pointer;margin-right: 16px;color: #000;" @click="$router.push({ path: `/guide` });">
              <p>返回首页</p>
              <p style="text-align: center">Home</p>
            </div>
            <el-dropdown style="cursor: pointer;">
              <div class="flex">
                <img :src="user.sex === 'female' ? legend.headImg1 : legend.headImg2" style="width: 50px;"/>
                <div style="text-align: center;margin-left: 10px;color: #000;">
                  <p style="font-size: 16px;">{{ user.realName }}</p>
                  <p style="font-size: 14px;margin-top:3px">
                    <el-tag
                      size="mini"
                      effect="plain"
                      :type="roleLabels(user.userType)">
                      {{user.roleName}}
                    </el-tag>
                  </p>
                </div>
              </div>
              <el-dropdown-menu slot="dropdown" style="border: none" class="mouseAnim">
                <div style="padding: 10px 20px;cursor: pointer;" class="personalCenter">
                  <p @click="personalCenter()">个人中心</p>
                </div>
                <div style="padding: 10px 20px;cursor: pointer;" class="signOut">
                  <p @click="signOut()">退出</p>
                </div>

              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div style="padding-top: 80px;"></div>
  </div>
</template>

<script>
export default {
  name: "top",
  data() {
    return {
      user: {},
      time: "",
      timer: "", //定时器
      style:false,
      legend: {
        headImg2: require("../../img/svg/useHead.svg"),
        headImg1: require("../../img/svg/useHeadFemale.svg"),
      },
    };
  },
  methods: {
    toggleSideBar() {
      this.api.mutations.TOGGLE_SIDEBAR(this.api.state);
      this.userApp();
    },
    userApp(){
    },
    changshi(){
      this.$route.fullPath == '/home' ? this.style = true : this.style = false;
    },
    personalCenter(){
      this.$router.push({path:'/personalCenter'})
    },
    //退出
    signOut() {
      var that = this;
      that.post("user/logout", {}).then(function (res) {
        if (res.data.code == 200) {
          window.localStorage.clear();
          that.$router.push({path: "/"});
          that.$message({
            message: res.data.msg,
            type: "success",
          });
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    roleLabels(rs){
      if(rs == "admin"){
        return "danger"
      }else if(rs == "operatorCleaner"){
        return "success"
      }else if(rs != "admin" || rs!="operatorCleaner"){
        return ""
      }
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("data"))
    this.changshi();
    //定时器-日期
    this.timer = setInterval(() => {
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      this.time = yy + "-" + mm + "-" + dd + " — " + hh + ":" + mf + ":" + ss;
    }, 1000);
  },
};
</script>
<style scoped>
.bagimg {
  box-sizing: border-box;
  width: calc(100% - 280px);
  height: 60px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: #fff;
  position: fixed;
  display: flex;
  left: 280px;
  align-items: center;
  justify-content: space-between;
  z-index: 99;
  border-bottom: 1px solid #ddd;
  transition: 580ms 0s;
}

p {
  margin: 0;
}

.vertical {
  display: inline-block;
  height: 48px;
  width: 2px;
  margin: 0 20px;
  background-color: #ffffff30;
}

.hamburger-container {
  line-height: 70px;
  height: 100%;
  float: left;
  cursor: pointer;
}

.is-action {
  width: 100%;
  left: 0;
}

.bagimg.is-active {
  transform: rotate(180deg);
}
.decorate{
  margin-top: 30px;
  display: flex;
  flex-direction: column;
}
.decorate2{
color: #11E2FF;
  width: 80%;
  height: 100%;
}
.decorate3{
  color: #000;
}
.decorate4{
  color: #fFF;
}
.dv8{
  top: 10px;
  left: 18%;
  position: absolute;
  width:300px;
  height:50px;
}
.dv8s{
  top: 10px;
  right: 18%;
  position: absolute;
  width:300px;
  height:50px;
}
.main-top{
  position: relative;
}
.dv5{
  position:absolute;
  width:500px;
  height:20px;
  top:70px;
  left: 50%;
  transform:translate(-50%,-50%);
}
.mouseAnim .personalCenter:hover{
  background: #409EFF;
  color: #ffffff;
}

.mouseAnim .signOut:hover{
  background: #409EFF;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/top.vue